export default {
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  Close: 'Close',
  Save: 'Save',
  Refresh: 'Refresh',
  View: 'View',
  LastUpdated: 'Last updated #{updatedTime}',
  Now: 'Now',
  Of: 'of',
  Description: 'Description',
  ClickToEditDescription: 'Click to edit description',
  ConfirmTheAction: 'Confirm the action',
  ResetConfirm: 'Reset to default settings?',
  DeleteConfirm: 'Are you sure you want to delete? It will be lost forever.',
  CancelConfirm: 'Are you sure you want to cancel this event?',
  ShowMore: 'Show more',
  ShowLess: 'Show less',
  AddFilter: 'Add filter',
  ClearAllFilters: 'Clear all filter',
  Add: 'Add',
  Delete: 'Delete',
  Loading: 'Loading...',
  Accept: 'Accept',
  Decline: 'Decline',
  Yes: 'Yes',
  No: 'No',
  Print: 'Print',
};
